import { CustomiseCardStepModel, ICustomiseCardStepModel } from "./CustomiseCardStep.model";
import { CustomiseMailStepModel, ICustomiseMailStepModel } from "./CustomiseMailStep.model";

export interface ICustomiseCardSubpageModel {
    customiseCard: ICustomiseCardStepModel;
    customiseMail: ICustomiseMailStepModel;
}

export class CustomiseCardSubpageModel implements ICustomiseCardSubpageModel {
    customiseCard: ICustomiseCardStepModel;
    customiseMail: ICustomiseMailStepModel;

    constructor() {
        this.customiseCard = new CustomiseCardStepModel();
        this.customiseMail = new CustomiseMailStepModel();
    }

    static isValid(model: ICustomiseCardSubpageModel): boolean {
        return CustomiseCardStepModel.isValid(model.customiseCard) &&
            CustomiseMailStepModel.isValid(model.customiseMail);
    }
}